import React from 'react';
import { TYPNAMN, datum, visning } from './minaArendenStatus';

/**
 * Listan i fliken Mina ärenden (BL-377, mina-forslag-komponentspec.md avsnitt 1–4).
 * Platta rader med border-bottom, nyaste först. Raden är en knapp som öppnar ärendet.
 */

export function IkonPil({ vand = false, className = 'mf-rad__pil' }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"
      strokeLinecap="round" aria-hidden="true" style={vand ? { transform: 'rotate(180deg)' } : undefined}>
      <path d="M6 4l4 4-4 4" />
    </svg>
  );
}

export function IkonFil() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
    </svg>
  );
}

function IkonArkiv() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="3" width="12" height="3" rx="1" /><path d="M3 6v6.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6" /><path d="M6.5 8.5h3" />
    </svg>
  );
}

function IkonPlus() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
      <path d="M8 3v10M3 8h10" />
    </svg>
  );
}

export function Statusetikett({ rad }) {
  const v = visning(rad);
  return <span className={`mf-status mf-status--${v.farg}`}>{v.label}</span>;
}

function Skelett() {
  return (
    <div aria-hidden="true">
      {[70, 55, 62].map((b) => (
        <div className="mf-skel" key={b}>
          <div className="mf-skel__ruta mf-skel__ruta--ikon" />
          <div className="mf-skel__text">
            <div className="mf-skel__ruta" style={{ width: `${b}%`, height: 12 }} />
            <div className="mf-skel__ruta" style={{ width: `${b - 25}%`, height: 10 }} />
          </div>
          <div className="mf-skel__ruta mf-skel__ruta--status" />
        </div>
      ))}
    </div>
  );
}

/**
 * @param {{ rader: Array|null, fel: string, nya: Set, onOppna: (ref: string) => void,
 *           onForsok: () => void, onNytt: () => void }} props
 */
export default function MinaArendenLista({ rader, fel, nya, onOppna, onForsok, onNytt }) {
  if (fel) {
    return (
      <div className="mf-tomt" role="alert">
        <p className="mf-tomt__titel">Det gick inte att hämta dina ärenden</p>
        <p className="mf-tomt__text">{fel}</p>
        <button type="button" className="forslag-btn forslag-btn--sek" onClick={onForsok}>Försök igen</button>
      </div>
    );
  }
  if (!rader) return <Skelett />;
  if (!rader.length) {
    return (
      <div className="mf-tomt">
        <div className="mf-tomt__ikon"><IkonArkiv /></div>
        <p className="mf-tomt__titel">Du har inte skickat något ärende än</p>
        <p className="mf-tomt__text">När du rapporterar en bugg, föreslår en förbättring eller ställer en fråga kan du följa den här.</p>
        <button type="button" className="forslag-btn forslag-btn--primar" onClick={onNytt}><IkonPlus />Nytt ärende</button>
      </div>
    );
  }
  return (
    <>
      <p className="mf-intro">Här ser du allt du har skickat in och hur långt det har kommit.</p>
      <ul className="mf-lista">
        {rader.map((r) => (
          <li key={r.ref}>
            <button type="button" className="mf-rad" data-ref={r.ref} onClick={() => onOppna(r.ref)}>
              <span className="mf-rad__ikon"><IkonFil /></span>
              <span className="mf-rad__kropp">
                <span className="mf-rad__titel">{r.rubrik}</span>
                <span className="mf-rad__meta">
                  {[r.ref, TYPNAMN[r.typ] || 'Ärende', datum(r.skapad), r.dubblett ? null : r.bl].filter(Boolean).join(' · ')}
                </span>
              </span>
              <span className="mf-rad__hoger">
                {nya.has(r.ref) && <span className="mf-ny" role="img" aria-label="Ny status" />}
                <Statusetikett rad={r} />
                <IkonPil />
              </span>
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
